/**
 * The related layout components rollouts.
 */
export const EXPERIMENTS = {
    GOATS_APP_BOTTOM_SHEET_MOBILE: '3614',
AUTOCOMPLETE_LOCALIZED: '3320',
GOATS_GUEST_BOTTOM_APP_BANNER: '3947',
LIONS_BANNER_LOCAL_SITE_REDIRECT: '4179',
LYNXES_MODERN_GUEST_SIDEBAR: '4904',
LYNXES_MODERN_HEADER_ENTRY: '4907',
LYNXES_QUESTIONNAIRE_EMAIL_CHECK: '4873',
LYNXES_USER_QUESTIONNAIRE_ROUTING: '4785',
MIXPANEL_RECORD_SESSION_PERCENT_LIMIT: '4931',
MUSTANGS_MP_NAV_BAR_JOB_POST_EP: '4854',
MUSTANGS_PRO_NAV_BAR_JOB_POST_EP: '4853',
MUSTANGS_ROUTING_SEARCH_BAR: '4706',
LIONS_NAVIGATION_ITEMS_FOR_GERMAN_AUDIENCE: '4241',
NEW_MUSTANGS_MP_NAV_BAR_JOB_POST_EP: '4902'
} as const;
